export default "__VITE_ASSET__BboJuDbk__"